import { useHeight } from '@xzx-design/hooks'

import type { BEM } from '@xzx-design/hooks'
import type { Ref } from 'vue'

export function usePlaceholder(contentRef: Ref<Element | undefined>, bem: BEM) {
  const height = useHeight(contentRef, true)

  return (renderContent: () => JSX.Element) => (
    <div
      class={bem('placeholder')}
      style={{ height: height.value ? `${height.value}px` : undefined }}
    >
      {renderContent()}
    </div>
  )
}
